export default "__VITE_ASSET__66RmPAoR__"